import * as React from 'react';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import { PortalPageSection } from 'components/PortalStructure';
import { ItemCardList } from 'components';
import { IItemCardList } from 'models/itemcard';
import { IShoppingBasketItem } from 'models/cart/shoppingbasketitem';
import { ICartAction } from 'models/cart/cart';
import { formatCurrency, formatInteger } from 'helpers/common';
import { ShoppingBagRemovedItems } from '../ShoppingBagRemovedItems';

require('./style.css');

interface IProps {
	items: IShoppingBasketItem[];
	total: number;
	itemsTotal: number;
	shippingPrice: number;
	t?: (key: string, props?: any) => string;
	currencyKey: number;

	/* func props */
	goToShoppingBagStep?: () => ICartAction;
	goToProduct?: (id: string, target: string) => void;
	goToShop?: (id: string, target: string) => void;
}

interface ICheckoutItemCardList extends IItemCardList {
	currencyKey?: number;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class Checkout extends React.Component<IProps, {}> {
	constructor(props) {
		super(props);

		this.goToCard = this.goToCard.bind(this);
		this.goToShoppingBagStep = this.goToShoppingBagStep.bind(this);
	}

	private goToShoppingBagStep(e: any) {
		e.preventDefault();
		this.props.goToShoppingBagStep();
	}

	private goToCard(id: string, type: string, target: string) {
		switch (type) {
			case c.NODE_TYPE_SHOP:
				this.props.goToShop(id, target);
				break;

			case c.NODE_TYPE_PRODUCT:
				this.props.goToProduct(id, target);
				break;

			default:
				break;
		}
	}

	/** --------------RENDER ----------------------- */
	public render() {
		const { t, items, total, itemsTotal, shippingPrice, currencyKey } = this.props;

		const removedItems = items.filter((x) => x.shopId === null);
		const otherItems = items.filter((x) => x.shopId !== null);

		const listProps: ICheckoutItemCardList = {
			items: otherItems,
			itemType: c.NODE_TYPE_CHECKOUTPRODUCT_ITEM_CARD,
			currencyKey,
			goToCard: this.goToCard,
		};

		return (
			<div className="cartCheckout">
				<PortalPageSection>
					<div className="itemsCount">
						<span className="text">{t('Cart_Checkout_Label_ItemsCount', { count: formatInteger(items.length) })}</span>
					</div>
					<div className="editBtn">
						<a href="#" onClick={this.goToShoppingBagStep}>
							{t('BSPortal_Common_Edit')}
						</a>
					</div>
				</PortalPageSection>
				<div>
					<ShoppingBagRemovedItems items={removedItems} />
				</div>
				<div className="wrapperProductCards">
					<div>
						<ItemCardList {...listProps} />
					</div>
				</div>
				<PortalPageSection>
					<div>
						<div className="leftText">
							<span className="normalText">{t('BSPortal_Common_Subtotal')}</span>
						</div>
						<div className="rightPrice">{formatCurrency(currencyKey, itemsTotal)}</div>
					</div>
					<div>
						<div className="leftText">
							<span className="normalText">{t('BSPortal_Common_Shipping')}</span>
						</div>
						<div className="rightPrice">{formatCurrency(currencyKey, shippingPrice)}</div>
					</div>
				</PortalPageSection>
				<PortalPageSection>
					<div>
						<div className="leftText">{t('BSPortal_Common_Total')}:</div>
						<div className="rightPrice">{formatCurrency(currencyKey, total)}</div>
					</div>
				</PortalPageSection>
			</div>
		);
	}
}

export { Checkout };
